// @flow
import * as React from 'react';
import RecaptchaInput from 'components/RecaptchaInput';
import { configValue } from 'utils/config';
import Field from './Field';

const RecaptchaField = () =>
  configValue('google', 'recaptcha', 'enabled') ? (
    <Field
      name="gRecaptchaResponse"
      renderInput={({ values, updateValue }) => (
        <RecaptchaInput
          key={values.recaptchaKey}
          onChange={gRecaptchaResponse => {
            updateValue(gRecaptchaResponse);
          }}
        />
      )}
    />
  ) : null;

export default RecaptchaField;
